module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="notify result-error-info">\n\n	<h3>'+
((__t=( __('result_error_title') ))==null?'':__t)+
'</h3>\n	<p>'+
((__t=( registry("Engine.NoResultMessage") ))==null?'':__t)+
'</p>\n\n	';
 if ( showError ) { 
__p+='\n		<br>\n		[Nur für eingeloggte Nutzer sichtbar:]<br>\n		Fehlergrund: '+
((__t=( error ))==null?'':__t)+
'<br>\n		Bitte melden Sie dieses Problem dem Tramino-Support.\n	';
 } 
__p+='\n\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/engine/result-error.html
 ** module id = 62
 ** module chunks = 0
 **/